/*
 * AssignUser Messages
 *
 * This contains all the text for the AssignUser component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    classesFor: {
        id: 'app.containers.AssignUser.classesFor',
        defaultMessage: 'Classes for'
    },
    updated: {
        id: 'app.containers.AssignUser.confirmationMessage',
        defaultMessage: 'have been updated'
    }
});



// WEBPACK FOOTER //
// ./app/containers/assign-user/messages.js